import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { FiArrowLeft } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import JoinByCodeForm from '../components/groups/JoinByCodeForm';
import { getPendingInviteCode, isValidInviteCode } from '../utils/pendingGroupInvite';

function JoinGroup({ onJoinGroup }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // ?code= from a /join/:code redirect wins over the localStorage stash, which
  // is only there to bridge the email-confirmation redirect.
  const queryCode = searchParams.get('code');
  const initialCode = isValidInviteCode(queryCode)
    ? queryCode.toUpperCase().trim()
    : getPendingInviteCode();
  const initialCodeSource = isValidInviteCode(queryCode) ? 'url' : 'stash';

  const handleSuccess = async (group) => {
    if (onJoinGroup) await onJoinGroup();
    // Redirect to the joined group's details page
    setTimeout(() => {
      navigate(`/group/${group.invite_code || group.id}`);
    }, 300);
  };

  return (
    <div className="min-h-screen bg-app">
      <Helmet>
        <title>Join Group - TeeSync</title>
      </Helmet>
      <div className="max-w-lg mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-text-secondary hover:text-text-primary mb-6 group transition-colors"
          >
            <SafeIcon
              icon={FiArrowLeft}
              className="w-4 h-4 mr-2 group-hover:-translate-x-0.5 transition-transform"
            />
            <span className="text-sm font-medium">Back to Dashboard</span>
          </button>

          <h1 className="text-2xl font-bold text-text-primary mb-1">Join a Group</h1>
          <p className="text-sm text-text-secondary mb-6">
            {initialCode
              ? 'Check the details below, then confirm to join.'
              : 'Enter an invite code to join an existing golf group.'}
          </p>

          <div className="bg-surface rounded-lg border border-border-subtle shadow-card p-5">
            <JoinByCodeForm
              onSuccess={handleSuccess}
              onCancel={() => navigate('/')}
              submitLabel="Preview Group"
              initialCode={initialCode}
              initialCodeSource={initialCodeSource}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default JoinGroup;
